import * as React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ComponentType } from "react";

const queryClient = new QueryClient();

export function withQueryClient<P>(Component: ComponentType<P>) {
    return (props: P) => (
        <QueryClientProvider client={queryClient}>
            <Component {...props} />
        </QueryClientProvider>
    );
}
